import { NgModule } from '@angular/core'
import { MbBreadcrumbComponent } from './mb-breadcrumb.component'
import { ConfigModule } from '@spartacus/core'
import { RouterModule } from '@angular/router'
import { CommonModule } from '@angular/common'
import { LinkModule } from '../components/shared/link/link.module'
import { SafeHtmlModule } from '../pipes/sanitize-html/safe-html.module'

@NgModule({
  declarations: [
    MbBreadcrumbComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ConfigModule.withConfig({
      cmsComponents: {
        BreadcrumbComponent: {
          component: MbBreadcrumbComponent
        }
      }
    }),
    LinkModule,
    SafeHtmlModule
  ]
})
export class MbBreadcrumbModule {}
